var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTemplate4 = function SvgTemplate4(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M13 5H5C4.44772 5 4 5.44772 4 6V8C4 8.55228 4.44772 9 5 9H13C13.5523 9 14 8.55228 14 8V6C14 5.44772 13.5523 5 13 5Z",
    stroke: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M19 5H17C16.4477 5 16 5.44772 16 6V8C16 8.55228 16.4477 9 17 9H19C19.5523 9 20 8.55228 20 8V6C20 5.44772 19.5523 5 19 5Z",
    stroke: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M19 12H5C4.44772 12 4 12.4477 4 13V17C4 17.5523 4.44772 18 5 18H19C19.5523 18 20 17.5523 20 17V13C20 12.4477 19.5523 12 19 12Z",
    stroke: "currentColor"
  })));
};
export default SvgTemplate4;